var path = 'views/selectors/resourceCategoryList.html';
var html = "<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"category in resourceCategorySearchList\"  ng-click=\"selectResourceCategory(category)\" id=\"listItem{{category.id}}\">\n          <div class=\"listRowItem itemNumber\">{{category.name}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/views/selectors/resourceCategoryList.html
// module id = OHjz
// module chunks = 0